import { render, staticRenderFns } from "./BloodSugar.vue?vue&type=template&id=444e2f8d&scoped=true&"
import script from "./BloodSugar.vue?vue&type=script&lang=js&"
export * from "./BloodSugar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444e2f8d",
  null
  
)

export default component.exports